import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  Ech0134meldungsempfaengerService,
  MeldungsEmpfaengerListEntry,
  MeldungsEmpfaengerSearchRequest
} from '../../../core/grundbuchmeldung-api';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { DeleteCheckModalComponent } from '../../../shared/components/modals/delete-check-modal/delete-check-modal.component';
import { NgbModal, NgbPagination, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { LoadingState } from 'app/shared/components/list-loader/loading-state';
import { lastValueFrom } from 'rxjs';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';

@Component({
  selector: 'cap-meldungsempfaenger-list',
  templateUrl: './meldungsempfaenger-list.component.html',
  styleUrls: ['./meldungsempfaenger-list.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ColumnHeaderComponent,
    LinkComponent,
    NgbTooltip,
    RouterLink,
    NgbPagination,
    TranslatePipe
  ]
})
export class MeldungsempfaengerListComponent implements OnInit {
  navTargets = NavTarget;
  loadingState = LoadingState;
  listLoader: ListLoader<MeldungsEmpfaengerListEntry>;
  tableSortModel = new TableSortModel<MeldungsEmpfaengerListEntry>('table', this.comparatorService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private comparatorService: ComparatorService,
    private backend: Ech0134meldungsempfaengerService,
    private modalService: NgbModal,
    private location: Location,
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.listLoader = this.route.snapshot.data.listLoader;
    this.tableSortModel.addColumn('bezeichnung', undefined, MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum.BEZEICHNUNG);
    this.tableSortModel.addColumn('sedexId', undefined, MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum.SEDEX_ID);
    this.tableSortModel.addColumn(
      'erhaeltMeldungen',
      undefined,
      MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum.ERHAELTMELDUNGEN
    );
    this.tableSortModel.addColumn(
      'erhaeltVertraulicheDaten',
      undefined,
      MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum.ERHAELTVERTRAULICHEDATEN
    );
    this.listLoader.applySortModel(this.tableSortModel);
    if (this.listLoader.allDataLoadedNoItemsFound) {
      this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, true);
      this.location.back();
    }
  }

  onNew() {
    this.router.navigate(['../new'], {
      relativeTo: this.route
    });
  }

  onDelete(item: MeldungsEmpfaengerListEntry) {
    const modal = this.modalService.open(DeleteCheckModalComponent);
    modal.componentInstance.entity = item.bezeichnung + ' - ' + item.sedexId;
    modal.result.then(() => {
      lastValueFrom(this.backend.deleteEmpfaenger(item.id.id)).then(() => {
        this.listLoader.remove(item);
      });
    });
  }
}
